/* global jQuery */
import Swiper, { Autoplay } from 'swiper'

export default class HandleWidgets {
  constructor () {
    this.handleProgram()
    this.handleSwiper()
  }

  handleProgram () {
    const that = this
    window.addEventListener('resize', function (event) {
      jQuery('.mtt-image-program-menu__image-container').each(function (index, el) {
        that.handleProgramCallback(el)
      })
    }, true);

    jQuery('.mtt-image-program-menu__image-container').each(function (index, el) {
      that.handleProgramCallback(el)
    })
  }

  handleSwiper () {
    let swiperContainer = document.querySelectorAll('.mtt-image-slider .swiper-container')
    if (swiperContainer.length > 0) {
      for (let i = 0; i < swiperContainer.length; i++) {
        const container = swiperContainer[i]
        const counter = container.querySelectorAll('.swiper-slide').length

        let swiper = new Swiper(container, {
          modules: [Autoplay],
          speed: 800,
          spaceBetween: 8,
          slidesPerView: 3,
          threshold: 8,
          grabCursor: false,
          allowTouchMove: false,
          loop: true,
          initialSlide: 0,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          breakpoints: {
            581: {
              spaceBetween: 16,
            },
          },
        })

        if (counter <= 3) {
          swiper.autoplay.stop()
        }
      }
    }
  }

  handleProgramCallback (el) {
    let element = jQuery(el)

    if (jQuery(document).width() >= 961) {
      let height = element.parent().find('.mtt-image-program-menu__text-container').outerHeight()

      element.parent().find('.mtt-image-program-menu__image-container').outerHeight(height)
    } else {
      element.parent().find('.mtt-image-program-menu__image-container').height('200px')
    }
  }

}
